import { Component, createRef } from 'react'
import PropTypes from 'prop-types'

import { Form, ListGroup } from 'react-bootstrap'

import styles from './../style/Korzina.module.scss'
import icon_styles from './../style/InputIcons.module.scss'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.adresInput = createRef()

    this.onClickHandler = this.onClickHandler.bind(this)
    this.onClickOutsideHandler = this.onClickOutsideHandler.bind(this)

    this.state = {
      adres: ``,
      delivery_arr: [],
      delivery: 0,
      delivery_loading: true,
      delivery_price: 0,
      modalShow: false,
      coords: [ 55.761447, 37.617181 ],
      isOpen: false
    }
  }

  setDMethod( delivery ) {
    this.setState({
      delivery: delivery
    }, () => {
      const { delivery, adres } = this.state
      this.props.setDelivery( delivery, 0, adres, 0 )
    })
  }

  findAdres = ( adres ) => {
    this.setState({
      adres: adres
    }, () => {
      const { delivery, adres } = this.state
      this.props.setDelivery( delivery, 0, adres, 0 )
    })
  }

  onReady() {
    this.setState({
      delivery_loading: false
    })
  }

  componentDidMount() {
    const { ajax_data } = this.props

    window.console.log( ajax_data.deliverys )

    window.addEventListener('click', this.onClickOutsideHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onClickOutsideHandler);
  }

  onClickHandler() {
    this.setState({
      isOpen: true
    })
  }

  onClickOutsideHandler(event) {
    if (this.state.isOpen && !this.adresInput.current.contains(event.target)) {
      this.setState({ isOpen: false })
    }
  }

  closeAdres() {
    this.setState({
      isOpen: false
    })
  }

  render() {

    const { delivery, adres, isOpen } = this.state,
    { ajax_data, priceFormat, payment } = this.props

    return (
      <>
        <div className={styles.korzina_form_title}>Способы доставки</div>
        <div className={styles.korzina_delivery_block + ` d-flex align-items-center`}>
          {'Доставка в пункт выдачи' in ajax_data.deliverys &&
            <div className={styles.korzina_form_checkbox_container}>
              {ajax_data.deliverys['Доставка в пункт выдачи'].map( ( delivery_el, k ) => {
                if(delivery_el?.arr.includes(payment)) return (
                  <div onClick={() => this.setDMethod( delivery_el.id )} key={k} className={styles.korzina_form_checkbox}>
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                      {delivery_el.id == delivery &&
                        <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                      }
                    </svg>
                    <div>
                      <div className={delivery_el.id == delivery ? styles.korzina_form_checkbox_name_active : styles.korzina_form_checkbox_name}>{delivery_el.name}{delivery_el.sum > 0 ? ` + ` + priceFormat(delivery_el.sum) + `₽` : ``}</div>
                    </div>
                  </div>
                )
              })}
              <div className={styles.korzina_form_checkbox_container_text}>Доставка в пункт выдачи</div>
            </div>
          }
          {'От двери до двери' in ajax_data.deliverys &&
            <div className={styles.korzina_form_checkbox_container}>
              {ajax_data.deliverys['От двери до двери'].map( ( delivery_el, k ) => {
                if(delivery_el?.arr.includes(payment)) return (
                  <div onClick={() => this.setDMethod( delivery_el.id )} key={k} className={styles.korzina_form_checkbox}>
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                      {delivery_el.id == delivery &&
                        <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                      }
                    </svg>
                    <div>
                      <div className={delivery_el.id == delivery ? styles.korzina_form_checkbox_name_active : styles.korzina_form_checkbox_name}>{delivery_el.name}{delivery_el.sum > 0 ? ` + ` + priceFormat(delivery_el.sum) + `₽` : ``}</div>
                    </div>
                  </div>
                )
              })}
              <div className={styles.korzina_form_checkbox_container_text}>От двери до двери</div>
            </div>
          }
        </div>
        <div className={styles.korzina_delivery_block + ` d-flex align-items-center`}>
          <div className={styles.korzina_form_checkbox_container_simple}>
            {'' in ajax_data.deliverys && ajax_data.deliverys[''].map( ( delivery_el, k ) => {
              if(delivery_el?.arr.includes(payment)) return (
                <div onClick={() => this.setDMethod( delivery_el.id )} key={k} className={styles.korzina_form_checkbox}>
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                    {delivery_el.id == delivery &&
                      <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                    }
                  </svg>
                  <div>
                    <div className={delivery_el.id == delivery ? styles.korzina_form_checkbox_name_active : styles.korzina_form_checkbox_name}>{delivery_el.name}{delivery_el.sum > 0 ? ` + ` + priceFormat(delivery_el.sum) + `₽` : ``}</div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        {delivery != 5 &&
          <div className={styles.korzina_form_adres} ref={this.adresInput}>
            <div className={styles.korzina_form_title + ` mt-0`}>Адрес доставки</div>
            <Form.Control
              onClick={this.onClickHandler}
              value={adres}
              onChange={( e ) => this.findAdres( e.target.value )}
              className={`${styles.korzina_form_input} ${icon_styles.adres_input}`} 
              type="text"
              placeholder="Населенный пункт, улица, дом, кв"
            />
            {ajax_data.user.authorized &&
              <>
                {ajax_data.user.adres.length > 0 &&
                  <>
                    {isOpen &&
                      <ListGroup className={styles.korzina_form_adres_surgestions}>
                        {ajax_data.user.adres.map( ( str, k ) => {
                          return (
                            <ListGroup.Item key={k} onClick={() => {
                              this.closeAdres()
                              this.findAdres( str )
                            }}>{str}</ListGroup.Item>
                          )
                        } )}
                      </ListGroup>
                    }
                  </>
                }
              </>
            }
          </div>
        }
      </>
    )
  }
}
Main.propTypes = {
  ajax_data: PropTypes.object,
  priceFormat: PropTypes.func,
  setDelivery: PropTypes.func,
  delivery_price: PropTypes.number,
  cart: PropTypes.array,
  sum: PropTypes.number,
  payment: PropTypes.number
}